export const cbc = (value, chain=undefined) => {
    if (chain === undefined) {
        chain = value;
        return cbc1(undefined, chain);
    } else {
        return cbc1(value, chain);
    }
};
export const cc = cbc;
const cbc1 = (value, chain) => {
    const [first, ...last] = chain;
    return first(value, (newValue) => {
        return cbc1(newValue, last);
    });
};
